import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
//Carousel
import Carousel from "react-bootstrap/Carousel";
//logo
import logo1 from "./assete/ejra/logo1.png";
//photo
import pic1 from "./assete/ejra/pic1.png";
import pic2 from "./assete/ejra/pic2.png";
import pic3 from "./assete/ejra/pic3.png";
import pic4 from "./assete/ejra/pic4.png";
const Ejra = () => {
  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <Box
            component="div"
            className="logo"
            sx={{
              display: "flex",

              justifyContent: "center",
              margin: "20px 0px",
            }}
          >
            <img src={logo1} alt="Logo" style={{ width: "10%" }}></img>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" className="text" sx={{ marginTop: "20px" }}>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
                marginBottom: "15px",
              }}
            >
              <li>سیستم کنترل ، مانیتورینگ و ابزار دقیق واحد اپراتور</li>
              <li>
                راه اندازی مجدد و رفع ایراد سیستم کنترل و مانیتورینگ دستگاه های
                پرس بوخر
              </li>
              <li>
                سیستم کنترل ، مانیتورینگ و ابزار دقیق واحد های دریافت فاینینگ و
                <span style={{ fontFamily: "roboto", fontSize: "1rem" }}>
                  CIP
                </span>{" "}
                سالن کنسانتره
              </li>
            </ul>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div">
            <Carousel
              style={{
                marginTop: "20px",
                width: "100%",
                height: "50%",
                float: "left",
              }}
            >
              <Carousel.Item>
                <img src={pic1} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic2} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic3} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic4} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
            </Carousel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default Ejra;
